import DrawerHoc from './DrawerHOC';

export default DrawerHoc;
